import {
TASK_TYPE_LIST_REQUEST,
TASK_TYPE_LIST_SUCCESS,
TASK_TYPE_LIST_FAIL,
} from '../constants/taskTypeConstants'
import api from "../core/api";

export const listTaskType = () => async (dispatch, getState) => {
  try {
    dispatch({ type: TASK_TYPE_LIST_REQUEST });
    const { data } = await api.get(`/extras/GetTime`);

    var dt = data.Result;

    if (typeof dt == "string") {
      dispatch({
        type: TASK_TYPE_LIST_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: TASK_TYPE_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: TASK_TYPE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};